import * as actions from './ord-deallocate-single.actions';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Injectable, inject } from '@angular/core';
import { Observable, from } from 'rxjs';
import { SpxToasterAutoCloseSpeedEnum, spxToasterActions } from '@softpak/components/spx-toaster';
import { catchError, filter, map, mergeMap, withLatestFrom } from 'rxjs/operators';

import { ApiOrdMethod } from 'src/app/api/api-methods.ord';
import { OrdDeAllocateSingleActions } from './ord-deallocate-single.actions';
import { OrdFiltersActions } from '../ord-filters/ord-filters.actions';
import { SharedGenericService } from 'src/app/shared/services/shared-generic.service';
import { Store } from '@ngrx/store';
import ordMultiAllocateReducer from '../ord-multi-allocate/ord-multi-allocate.reducer';

@Injectable()
export class OrdDeallocateEffects {
    // Injects
    private readonly store = inject(Store);
    private readonly actions$ = inject(Actions);
    private readonly sharedGenericService = inject(SharedGenericService);

    afterLoad: Observable<any> = createEffect(() => this.actions$.pipe(
        ofType(OrdDeAllocateSingleActions.load),
        withLatestFrom(this.store.select(ordMultiAllocateReducer.selectModeIsActive)),
        filter(([action, multiAllocateIsActive]) => action.query.isMultiAllocate || !multiAllocateIsActive),
        mergeMap(([action, _]) => from(this.sharedGenericService.invoke(ApiOrdMethod.ordDeallocate, action.query))
            .pipe(
                map(result => OrdDeAllocateSingleActions.received({
                    result
                })),
                catchError((error) => {
                    console.error(error);
                    return [
                        OrdDeAllocateSingleActions.error({
                            error,
                        }),
                        spxToasterActions.createError({
                            autoClose: error.autoclose ? 5000 : undefined,
                            messageText: `${error?.title ? `${error?.title}: ` : ``} ${error.message}`,
                        }),
                    ];
                })
            )))
    );

    afterError$: Observable<any> = createEffect(() => this.actions$.pipe(
        ofType(OrdDeAllocateSingleActions.error),
        mergeMap((action) => [
            spxToasterActions.createError({
                messageText: `Error in allocation`,
                autoClose: SpxToasterAutoCloseSpeedEnum.DEFAULT,
            }),
        ]))
    );

    afterReceived$: Observable<any> = createEffect(() => this.actions$.pipe(
        ofType(OrdDeAllocateSingleActions.received),
        mergeMap((action) => [
            OrdFiltersActions.update({}),
        ]))
    );

}
